/** Returns a valid JSON object or an empty object if the value is not valid JSON */
export function safeJSONParse(
  value: string | null | undefined,
): Partial<Record<string, unknown>> {
  try {
    return JSON.parse(value || '{}')
  } catch {
    return {}
  }
}
